import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MobileAside from "../aside/MobileAside";
import { useDispatch, useSelector } from "react-redux";
import NotificationDropdown from "../notificathion/NotificationDropdown";
import { selectBellNotificationCount } from "../../redux/slices/bellNotificationSlice";

const MobileHeader = ({ email, formatPathname }) => {
  const [isAsideOpen, setIsAsideOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [renderAside, setRenderAside] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const unreadCount = useSelector(selectBellNotificationCount);

  const toggleDropdown = (e) => {
    setDropdownOpen(!dropdownOpen);
  };

  const openAside = () => {
    setRenderAside(true);
    setTimeout(() => setIsAsideOpen(true), 10);
  };

  const closeAside = () => {
    setIsAsideOpen(false);
    setTimeout(() => setRenderAside(false), 300);
  };

  const handleLogoClick = () => {
    navigate("/dashboard");
  };

  return (
    <>
      <div className="bg-white flex justify-between items-center py-4 px-4 ">
        <div className="flex items-center gap-3">
          <img
            src="/assets/mobileMenuIcon.png"
            alt="Menu"
            className="cursor-pointer"
            onClick={openAside}
          />
          <img
            src="/assets/MobileSmallLogo.png"
            alt="Logo"
            onClick={handleLogoClick}
          />
        </div>

        <div className="flex items-center gap-1.5">
          <div className="relative">
            <svg
              onClick={toggleDropdown}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="cursor-pointer"
            >
              <path
                d="M15 17H20L18.5951 15.5951C18.2141 15.2141 18 14.6973 18 14.1585V11C18 8.38757 16.3304 6.16509 14 5.34142V5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5V5.34142C7.66962 6.16509 6 8.38757 6 11V14.1585C6 14.6973 5.78595 15.2141 5.40493 15.5951L4 17H9M15 17V18C15 19.6569 13.6569 21 12 21C10.3431 21 9 19.6569 9 18V17M15 17H9"
                stroke="#181F46"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="px-1 bg-primary rounded-full text-center text-white prose-t11_regular absolute -top-2 -end-1">
              {unreadCount === 0 ? null : unreadCount}
              <div className="absolute top-0 start-0 rounded-full -z-10 animate-ping bg-primary w-full h-full"></div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <span className="max-w-[120px] prose-t14_regular text-midnightBlue truncate block whitespace-nowrap overflow-hidden text-ellipsis">
              {email || "Էլ․ փոստը բացակայում է"}
            </span>
            <svg
              width="16"
              height="19"
              viewBox="0 0 16 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.537842 15.7791V16.3932C2.58481 18.0316 5.17851 19.0002 8.0035 19.0002C10.8285 19.0002 13.4222 18.0316 15.4621 16.3932V15.7791C15.4621 9.19334 0.537842 9.19334 0.537842 15.7791Z"
                fill="#64748B"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.0035 0.45874C5.49221 0.45874 3.45853 2.49241 3.45853 5.0046C3.45853 7.51501 5.49221 9.54868 8.0035 9.54868C10.5077 9.54868 12.5414 7.51501 12.5414 5.0046C12.5414 2.49241 10.5077 0.45874 8.0035 0.45874Z"
                fill="#64748B"
              />
            </svg>
          </div>
        </div>
      </div>

      {renderAside && <MobileAside isOpen={isAsideOpen} onClose={closeAside} />}

      <div className="lg:hidden flex  min-h-[46px] shadow-custom rounded-[20px] my-4">
        <span className="prose-t18_bold text-primary py-2.5 px-4 ">
          {formatPathname(location.pathname)}
        </span>
      </div>

      {dropdownOpen && (
        <NotificationDropdown setDropdownOpen={setDropdownOpen} />
      )}
    </>
  );
};

export default MobileHeader;
